import * as angular from "angular";
import * as _ from "lodash";
import {IQService} from "angular";
import {DeliveryUtilsService} from "../../deliveries/services/delivery-utils.service";
import {TaskModel} from "../../tasks/models/task.model";

export class MapRouteService {
  $$directionsService = null;
  $$rendererReferences = {};
  $$rendererConfig = {
    suppressMarkers: true
  };

  constructor(private $q: IQService, private uiGmapGoogleMapApi, private tasksConstants, private deliveryUtilsService: DeliveryUtilsService) {
  }

  getMapService() {
    return this.uiGmapGoogleMapApi;
  }

  draw(scope, map, services) {
    const deferred = this.$q.defer();

    if (_.isEmpty(services) || _.isUndefined(services)) {
      return this.$q.reject('Services resolved to empty or undefined! \n ' +
        '--> MapRouteService@draw');
    }

    this.uiGmapGoogleMapApi.then(
      (gMaps) => {

        if (_.isNull(this.$$directionsService)) {
          this.$$directionsService = new gMaps.DirectionsService();
        }

        let routes = [];

        this.clear(scope);

        _.forEach(services, (service) => {
          if (this.isPlaceIdSetForBothTasks(service)) {
            let routePromise = this.drawRouteForService(scope, map, service, gMaps);
            routes.push(routePromise);
          }
        });

        this.$q.all(routes).then(deferred.resolve, deferred.reject);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  // ******************************
  // Internal methods
  // ******************************

  drawRouteForService(scope, map, service, gMaps) {
    let deferred = this.$q.defer();

    let directionsRenderer = new gMaps.DirectionsRenderer(this.$$rendererConfig),
      routeRequest = {
        origin: this.getTasCordsByPurpose(service.taskList, this.tasksConstants.purposes.pickup, gMaps),
        destination: this.getTasCordsByPurpose(service.taskList, this.tasksConstants.purposes.dropoff, gMaps),
        travelMode: gMaps.DirectionsTravelMode.DRIVING
      };

    this.$$directionsService.route(routeRequest, (response, status) => {

      if (_.isEqual(status, gMaps.DirectionsStatus.OK)) {

        directionsRenderer.setMap(map);
        directionsRenderer.setDirections(response);

        this.addDirectionRendererAsReference(scope, directionsRenderer);

        deferred.resolve();

      } else {
        deferred.reject(status);
      }

    });

    return deferred.promise;
  }

  isPlaceIdSetForBothTasks(service) {
    var taskList = service.taskList,
      valid = false;

    _.forEach(taskList, function (task: TaskModel) {
      var placeId = task.taskSpec.address.placeId;
      valid = !(_.isEmpty(placeId) || _.isUndefined(placeId));
    });

    return valid;
  }

  getTasCordsByPurpose(taskList, purpose, gMaps) {
    let task = this.deliveryUtilsService.getTaskByPurpose(taskList, purpose),
      cords = _.get(task, 'taskSpec.address.location');
    return new gMaps.LatLng(cords.lat, cords.lng);
  }

  addDirectionRendererAsReference(scope, directionsRenderer) {
    let container: any[] = _.get(this.$$rendererReferences, scope.$id);
    if (_.isUndefined(container)) {
      _.set(this.$$rendererReferences, scope.$id, [directionsRenderer]);
    } else {
      container.push(directionsRenderer);
    }
  }

  clear(scope) {
    const container = _.get(this.$$rendererReferences, scope.$id);
    if (!_.isUndefined(container)) {
      _.forEach(container, (renderer: any) => {
        renderer.setMap(null);
      });
      _.unset(this.$$rendererReferences, scope.$id);
    }
  }

}

angular
  .module('bringoz.admin.map')
  .service('mapRouteService', MapRouteService);
